import React, { useState, memo, useRef } from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { isMobile } from "react-device-detect";
import coverVideo from "../../../../../src/assets/images/test.png";
import { IconPlayFill } from "../../../../assets/icons";

function SliderItem({ index, ItemData }) {
  const [isImageLoad, setIsImageLoad] = useState(false);
  const screenWidth = window.innerWidth;

  const videoRef = useRef();

  const [stop, setStop] = useState(false);

  const handleVideo = () => {
    setStop(!stop);
    if (stop == true) {
      videoRef.current.pause();
    } else videoRef.current.play();
  };

  return (
    <SkeletonTheme baseColor="#cecdcd" highlightColor="#e2dfdf">
      {ItemData?.gallery?.option === 1 ? (
        <div
          className="  pb-0"
          style={
            !isImageLoad
              ? { backgroundColor: "#cecdcd", height: "250px" }
              : isMobile
              ? { height: "" }
              : { height: "" }
          }
        >
          {!isImageLoad && (
            <div
              className="mt-0 my-0 py-0 my-0 py-0 h-100 d-flex w-100  "
              style={{ borderRadius: "0.5rem", backgroundColor: "#cecdcd" }}
            >
              <div className=" my-0 d-lg-none">
                {" "}
                <Skeleton
                  width="100vw"
                  height="70vw"
                  className=" my-0 d-md-none"
                />{" "}
              </div>

              <div className=" my-0 d-none d-lg-block">
                {" "}
                <Skeleton
                  width="100vw"
                  height="70vw"
                  className=" my-0 d-none d-lg-block"
                />{" "}
              </div>
            </div>
          )}

          <img
            width={!isImageLoad ? 0 : ""}
            height={!isImageLoad ? 0 : ""}
            onLoad={() => setIsImageLoad(true)}
            className={isImageLoad ? "  rounded-4  my-0 py-0 " : ""}
            src={
              process.env.REACT_APP_API_URL +
              ItemData?.gallery?.imageUrl +
              (isMobile ? "?width=340" : "?width=422")
            }
            alt={ItemData?.gallery?.imageAlt}
          />
        </div>
      ) : (
        <>
          <div
            key={index}
            id={ItemData?.gallery?.id}
            className=" w-100 h-100 p-0 "
            style={{
              // height: isMobile ? "270px" : "300px",
              backgroundColor: "#000",
            }}
          >
            {!stop && (
              <div className="w-100 text-center play-video-icon">
                <IconPlayFill color="#fff" />
              </div>
            )}
            <div
              className="w-100"
              style={{ position: "absolute", zIndex: "2", height: "60%" }}
              onClick={() => {
                handleVideo();
              }}
            ></div>
            {!stop && (
              <div
                className="w-100 bg-dark opacity-50"
                style={{ position: "absolute", zIndex: "1", height: "100%" }}
              ></div>
            )}
            <video
              poster={coverVideo}
              ref={videoRef}
              controlsList="nodownload"
              onPause={() => {
                setStop(false);
              }}
              onPlay={() => {
                setStop(true);
              }}
              loading="lazy"
              width={!isImageLoad ? 0 : ""}
              height={!isImageLoad ? 0 : ""}
              onLoad={() => setIsImageLoad(true)}
              src={process.env.REACT_APP_API_URL + ItemData?.gallery?.imageUrl}
              alt={ItemData?.gallery?.imageAlt}
              className="w-100 fullscreen h-100 "
              controls
            />
            <div
              style={
                !isImageLoad
                  ? {}
                  : { position: "absolute", top: "45%", right: "35%" }
              }
            ></div>
          </div>
        </>
      )}
    </SkeletonTheme>
  );
}

export default memo(SliderItem);
